import { Suspense } from "react";
import PropTypes from "prop-types";
import { AppLoader } from "_lib";

const AppSuspense = (props) => {
  const { children } = props;
  return <Suspense fallback={<AppLoader />}>{children}</Suspense>;
};
AppSuspense.propTypes = {
  children: PropTypes.node.isRequired,
};
export default AppSuspense;
